<div class="container">
  <div class="col-12 border-bottom pt-3 mb-3 bg-light">
    <h3>Dauphiné dentaire</h3>
  </div>
</div>
